import { Mesh, CylinderGeometry, MeshPhongMaterial, PlaneGeometry, MeshStandardMaterial, TextureLoader, MeshBasicMaterial } from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';


export default class Posts {

    constructor(GAME) {
        this.GAME = GAME;
        this.init();
    }

    init() {

        this.material = new MeshStandardMaterial({
            color: 0xfcc742,
            emissive: 0x111111,
            metalness: 1,
            roughness: 0.5,
        });

        this.addLeftPost();
        this.addRightPost();
        this.addMiddlePost();
        this.addLeftPadding();
        this.addRightPadding();
        this.addBranding();
    }

    addLeftPost() {
        this.GAME.postLeft = new Mesh(
            new CylinderGeometry(this.GAME.config.postLeft.diameter, this.GAME.config.postLeft.diameter, this.GAME.config.postLeft.height, 10),
            this.material
        );
        this.GAME.postLeft.position.set(this.GAME.config.postLeft.position.x, this.GAME.config.postLeft.position.y, this.GAME.config.postLeft.position.z);
        this.GAME.postLeft.castShadow = true;
        this.GAME.scene.add(this.GAME.postLeft);
    }

    addRightPost() {
        this.GAME.postRight = new Mesh(
            new CylinderGeometry(this.GAME.config.postRight.diameter, this.GAME.config.postRight.diameter, this.GAME.config.postRight.height, 10),
            this.material
        );
        this.GAME.postRight.position.set(this.GAME.config.postRight.position.x, this.GAME.config.postRight.position.y, this.GAME.config.postRight.position.z);
        this.GAME.postRight.castShadow = true;
        this.GAME.scene.add(this.GAME.postRight);

    }

    addMiddlePost() {
        this.GAME.postMiddle = new Mesh(
            new CylinderGeometry(this.GAME.config.postMiddle.diameter, this.GAME.config.postMiddle.diameter, this.GAME.config.postMiddle.height, 10),
            this.material
        );
        this.GAME.postMiddle.position.set(this.GAME.config.postMiddle.position.x, this.GAME.config.postMiddle.position.y, this.GAME.config.postMiddle.position.z);
        this.GAME.postMiddle.rotation.set(0, 0, Math.PI / 2);
        this.GAME.postMiddle.castShadow = true;
        this.GAME.scene.add(this.GAME.postMiddle);

    }

    addLeftPadding() {
        this.GAME.paddingLeftMesh = new Mesh(
            new RoundedBoxGeometry(this.GAME.config.paddingLeft.width, this.GAME.config.paddingLeft.height, this.GAME.config.paddingLeft.depth, 1, .05),
            new MeshPhongMaterial({ color: this.GAME.config.paddingLeft.colour4 })
        );
        this.GAME.paddingLeftMesh.position.set(this.GAME.config.paddingLeft.position.x, this.GAME.config.paddingLeft.position.y, this.GAME.config.paddingLeft.position.z);
        this.GAME.paddingLeftMesh.castShadow = true;
        this.GAME.scene.add(this.GAME.paddingLeftMesh);
    }

    addRightPadding() {
        this.GAME.paddingRightMesh = new Mesh(
            new RoundedBoxGeometry(this.GAME.config.paddingRight.width, this.GAME.config.paddingRight.height, this.GAME.config.paddingRight.depth, 1, .05),
            new MeshPhongMaterial({ color: this.GAME.config.paddingRight.colour4 })
        );
        this.GAME.paddingRightMesh.position.set(this.GAME.config.paddingRight.position.x, this.GAME.config.paddingRight.position.y, this.GAME.config.paddingRight.position.z);
        this.GAME.paddingRightMesh.castShadow = true;
        this.GAME.scene.add(this.GAME.paddingRightMesh);
    }

    addBranding() {
        this.loader = new TextureLoader();
        const { asset_directory } = this.GAME.config.constants;
        this.loader.load(asset_directory + 'branding-spark-new-stacked.png', (texture) => {

            const imageMaterial = new MeshBasicMaterial({ map: texture, transparent: true });
            imageMaterial.color.setScalar(0.2);

            // Plane geometry matching long side size
            const planeWidth = this.GAME.config.paddingLeft.width;
            const planeHeight = this.GAME.config.paddingLeft.height;
            const planeGeometry = new PlaneGeometry(planeWidth, planeHeight);


            this.leftPlaneFront = new Mesh(planeGeometry, imageMaterial);
            this.leftPlaneFront.position.set(
                this.GAME.config.paddingLeft.position.x,
                this.GAME.config.paddingLeft.position.y + .025,
                this.GAME.config.paddingLeft.position.z + (this.GAME.config.paddingLeft.width / 2) + .001,
            );
            this.GAME.scene.add(this.leftPlaneFront);

            this.leftPlaneRight = new Mesh(planeGeometry, imageMaterial);
            this.leftPlaneRight.position.set(
                this.GAME.config.paddingLeft.position.x + (this.GAME.config.paddingLeft.width / 2) + .001,
                this.GAME.config.paddingLeft.position.y + .025,
                this.GAME.config.paddingLeft.position.z,
            );
            this.leftPlaneRight.rotation.y = Math.PI / 2;
            this.GAME.scene.add(this.leftPlaneRight);

            this.leftPlaneLeft = new Mesh(planeGeometry, imageMaterial);
            this.leftPlaneLeft.position.set(
                this.GAME.config.paddingLeft.position.x - (this.GAME.config.paddingLeft.width / 2) - .001,
                this.GAME.config.paddingLeft.position.y + .025,
                this.GAME.config.paddingLeft.position.z,
            );
            this.leftPlaneLeft.rotation.y = -Math.PI / 2;
            this.GAME.scene.add(this.leftPlaneLeft);



        });
        
        this.loader.load(asset_directory + 'branding-gallagher-new-stacked.png', (texture) => {

            const imageMaterial = new MeshBasicMaterial({ map: texture, transparent: true });
            // imageMaterial.color.setScalar(0.9);

            // Plane geometry matching long side size
            const planeWidth = this.GAME.config.paddingLeft.width;
            const planeHeight = this.GAME.config.paddingLeft.height;
            const planeGeometry = new PlaneGeometry(planeWidth, planeHeight);


           

            this.rightPlaneFront = new Mesh(planeGeometry, imageMaterial);
            this.rightPlaneFront.position.set(
                this.GAME.config.paddingRight.position.x,
                this.GAME.config.paddingRight.position.y + .025,
                this.GAME.config.paddingRight.position.z + (this.GAME.config.paddingRight.width / 2) + .001,
            );
            this.GAME.scene.add(this.rightPlaneFront);

            this.rightPlaneRight = new Mesh(planeGeometry, imageMaterial);
            this.rightPlaneRight.position.set(
                this.GAME.config.paddingRight.position.x + (this.GAME.config.paddingRight.width / 2) + .001,
                this.GAME.config.paddingRight.position.y + .025,
                this.GAME.config.paddingRight.position.z,
            );
            this.rightPlaneRight.rotation.y = Math.PI / 2;
            this.GAME.scene.add(this.rightPlaneRight);

            this.rightPlaneLeft = new Mesh(planeGeometry, imageMaterial);
            this.rightPlaneLeft.position.set(
                this.GAME.config.paddingRight.position.x - (this.GAME.config.paddingRight.width / 2) - .001,
                this.GAME.config.paddingRight.position.y + .025,
                this.GAME.config.paddingRight.position.z,
            );
            this.rightPlaneLeft.rotation.y = -Math.PI / 2;
            this.GAME.scene.add(this.rightPlaneLeft);
        });
    }


}
